export default class EmailHandler {
    constructor() {
        this.validationRules = {
            firstName: {
                required: true,
                minLength: 2,
                pattern: /^[a-zA-ZäöüÄÖÜß\s-]+$/,
                message: 'Vorname muss mindestens 2 Zeichen haben und darf nur Buchstaben enthalten :)'
            },
            lastName: {
                required: true,
                minLength: 2,
                pattern: /^[a-zA-ZäöüÄÖÜß\s-]+$/,
                message: 'Nachname muss mindestens 2 Zeichen haben und darf nur Buchstaben enthalten :)'
            },
            email: {
                required: true,
                pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: 'Bitte gib eine gültige E-Mail-Adresse ein :)'
            },
            phone: {
                required: false,
                pattern: /^[\d\s\-\+\(\)]+$/,
                message: 'Telefonnummer darf nur Zahlen, Leerzeichen und die Zeichen +()-/ enthalten :)'
            },
            message: {
                required: true,
                minLength: 10,
                maxLength: 1000,
                message: 'Nachricht muss zwischen 10 und 1000 Zeichen lang sein :)'
            }
        };
        this.init();
    }

    init() {
        // Initialize EmailJS with your public key
        emailjs.init('PwIwa-hzYpvDd4Ska');

        this.setupFormHandler();
        this.setupRealTimeValidation();
    }

    setupRealTimeValidation() {
        const form = document.getElementById('contact-form');
        if (!form) return;

        // Add validation to each input - only clear errors when user starts typing again
        Object.keys(this.validationRules).forEach(fieldName => {
            const field = form.querySelector(`[name="${fieldName}"]`);
            if (field) {
                // Clear error styling when user starts typing again (after a failed submission)
                field.addEventListener('input', () => {
                    if (field.classList.contains('error')) {
                        this.clearFieldError(field);
                    }

                    // Auto-resize textarea
                    if (field.tagName.toLowerCase() === 'textarea') {
                        this.autoResizeTextarea(field);
                    }
                });
            }
        });

        // Setup initial textarea size
        const messageField = form.querySelector('[name="message"]');
        if (messageField) {
            this.autoResizeTextarea(messageField);
        }
    }

    autoResizeTextarea(textarea) {
        // Reset height to measure content properly
        textarea.style.height = 'auto';

        // Set height constraints
        const minHeight = 80; // Match the min-height from CSS
        const maxHeight = 300; // Maximum height before scrolling appears (about 12-15 lines)
        const contentHeight = textarea.scrollHeight;

        if (contentHeight <= maxHeight) {
            // Content fits within max height - grow the textarea and hide scrollbar
            const newHeight = Math.max(minHeight, contentHeight);
            textarea.style.height = newHeight + 'px';
            textarea.style.overflowY = 'hidden';
        } else {
            // Content exceeds max height - fix height and show scrollbar
            textarea.style.height = maxHeight + 'px';
            textarea.style.overflowY = 'auto';
        }
    }

    validateField(field) {
        const fieldName = field.name;
        const value = field.value.trim();
        const rules = this.validationRules[fieldName];

        if (!rules) return true;

        // Clear previous error
        this.clearFieldError(field);

        // Check required
        if (rules.required && !value) {
            this.showFieldError(field, `${this.getFieldLabel(fieldName)} ist erforderlich`);
            return false;
        }

        // Skip other validations if field is empty and not required
        if (!value && !rules.required) {
            return true;
        }

        // Check minimum length
        if (rules.minLength && value.length < rules.minLength) {
            this.showFieldError(field, rules.message);
            return false;
        }

        // Check maximum length
        if (rules.maxLength && value.length > rules.maxLength) {
            this.showFieldError(field, rules.message);
            return false;
        }

        // Check pattern
        if (rules.pattern && !rules.pattern.test(value)) {
            this.showFieldError(field, rules.message);
            return false;
        }

        // Field is valid
        this.showFieldSuccess(field);
        return true;
    }

    validateForm() {
        const form = document.getElementById('contact-form');
        let isValid = true;

        Object.keys(this.validationRules).forEach(fieldName => {
            const field = form.querySelector(`[name="${fieldName}"]`);
            if (field) {
                if (!this.validateField(field)) {
                    isValid = false;
                }
            }
        });

        return isValid;
    }

    getFieldLabel(fieldName) {
        const labels = {
            firstName: 'Vorname',
            lastName: 'Nachname',
            email: 'E-Mail',
            phone: 'Telefon',
            message: 'Nachricht'
        };
        return labels[fieldName] || fieldName;
    }

    showFieldError(field, message) {
        field.classList.add('error');
        field.classList.remove('success');

        // Create or update error message
        let errorDiv = field.parentNode.querySelector('.field-error');
        if (!errorDiv) {
            errorDiv = document.createElement('div');
            errorDiv.className = 'field-error';
            field.parentNode.appendChild(errorDiv);
        }
        errorDiv.textContent = message;
    }

    showFieldSuccess(field) {
        field.classList.add('success');
        field.classList.remove('error');
        this.clearFieldError(field);
    }

    clearFieldError(field) {
        field.classList.remove('error', 'success');
        const errorDiv = field.parentNode.querySelector('.field-error');
        if (errorDiv) {
            errorDiv.remove();
        }
    }

    setupFormHandler() {
        const form = document.getElementById('contact-form');
        const messageDiv = document.getElementById('form-message');
        const submitBtn = form.querySelector('.submit-btn');

        if (!form) return;

        form.addEventListener('submit', async (e) => {
            e.preventDefault();

            // Validate form before submission
            if (!this.validateForm()) {
                this.showValidationError(messageDiv);
                return;
            }

            // Show loading state
            this.setLoadingState(submitBtn, messageDiv, true);

            try {
                // Send email using EmailJS
                const result = await emailjs.sendForm(
                    'service_mxuo776',    // Your service ID
                    'template_dqm3fpn',   // Your template ID
                    form
                );

                this.showSuccess(messageDiv);
                form.reset(); // Clear form
                this.clearAllFieldStates(form); // Clear validation states

            } catch (error) {
                console.error('Email send failed:', error);
                this.showError(messageDiv);
            } finally {
                this.setLoadingState(submitBtn, messageDiv, false);
            }
        });
    }

    showValidationError(messageDiv) {
        messageDiv.innerHTML = `
            <svg fill="none" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg" style="display: inline-block; vertical-align: middle; margin-right: 0.5rem;">
                <path xmlns="http://www.w3.org/2000/svg" d="M12 9V11M12 15H12.01M3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
            Bitte korrigiere die markierten Felder und versuche es erneut :)
        `;
        messageDiv.className = 'form-message error';
        messageDiv.style.display = 'block';

        setTimeout(() => {
            messageDiv.style.display = 'none';
        }, 5000);
    }

    clearAllFieldStates(form) {
        Object.keys(this.validationRules).forEach(fieldName => {
            const field = form.querySelector(`[name="${fieldName}"]`);
            if (field) {
                this.clearFieldError(field);
            }
        });
    }

    setLoadingState(submitBtn, messageDiv, isLoading) {
        if (isLoading) {
            submitBtn.textContent = 'Wird gesendet...';
            submitBtn.disabled = true;
            messageDiv.style.display = 'none';
        } else {
            submitBtn.textContent = 'Senden';
            submitBtn.disabled = false;
        }
    }

    showSuccess(messageDiv) {
        messageDiv.innerHTML = `
            <svg fill="none" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg" style="display: inline-block; vertical-align: middle; margin-right: 0.5rem;">
                <path xmlns="http://www.w3.org/2000/svg" d="M20.6644 5.2526C21.0772 5.61952 21.1143 6.25159 20.7474 6.66437L10.0808 18.6644C9.89099 18.8779 9.61898 19 9.33334 19C9.04771 19 8.7757 18.8779 8.58593 18.6644L3.2526 12.6644C2.88568 12.2516 2.92286 11.6195 3.33565 11.2526C3.74843 10.8857 4.3805 10.9229 4.74742 11.3356L9.33334 16.4948L19.2526 5.33565C19.6195 4.92286 20.2516 4.88568 20.6644 5.2526Z" fill="currentColor"></path>
            </svg>
            Nachricht erfolgreich gesendet! Ich melde mich bald bei dir :)
        `;
        messageDiv.className = 'form-message success';
        messageDiv.style.display = 'block';

        // Hide message after 5 seconds
        setTimeout(() => {
            messageDiv.style.display = 'none';
        }, 5000);
    }

    showError(messageDiv) {
        messageDiv.innerHTML = `
            <svg fill="none" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg" style="display: inline-block; vertical-align: middle; margin-right: 0.5rem;">
                <path xmlns="http://www.w3.org/2000/svg" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="currentColor"></path>
            </svg>
            Fehler beim Senden. Bitte versuche es erneut oder kontaktiere mich direkt unter contact@tomunger.me :)
        `;
        messageDiv.className = 'form-message error';
        messageDiv.style.display = 'block';

        // Hide message after 7 seconds
        setTimeout(() => {
            messageDiv.style.display = 'none';
        }, 7000);
    }
}
